import { Component, OnInit } from '@angular/core';

import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { DateAdapter } from '@angular/material/core';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { ModalConfirmComponent } from '../../modal-confirm/modal-confirm.component';
import * as decode from 'jwt-decode';
import { saveAs } from 'file-saver/FileSaver';
import { ModalErrorPaymentComponent } from '../../payments/modal-error-payment/modal-error-payment.component';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-invoices-report',
  templateUrl: './invoices-report.component.html',
  styleUrls: ['./invoices-report.component.scss']
})
export class InvoicesReportComponent implements OnInit {

  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  userId: any;
  userToken: any;
  listPayments: any = [];
  totalesMoneda: any = [];
  temp: any = [];
  load = true;
  step = 0;
  loadBtn = false;
  listSocieties = [];
  listYears = [];
  data: any = {};
  lang = 'es';
  arrOc = [];
  oc: any;
  perfilId;
  providerActive = false;
  isExternal;
  checkedAll = false;
  total = 0;
  totalLoc = 0;
  listPlanta = [];
  listPlantaSel = [];


  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService, private provService: ProvidersService, public translate: TranslateService, private adapter: DateAdapter<any>) {
    this.userToken = localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);
    this.userId = tokenPayload.Id;

    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;

    this.providerActive = (this.perfilId == '3' && this.isExternal) ? false : true;

    gralService.changeTextHead('REPORTBILLS');
    this.getSocieties();
    this.getPlantas();

    translate.onLangChange.subscribe(lang => {
      if (lang.lang == 'en') {
        this.adapter.setLocale('en-GB');
      }

      if (lang.lang == 'es') {
        this.adapter.setLocale('es-MX');
      }
    });
    const y = new Date();
    const n = y.getFullYear();
    this.listYears = [{ year: n }, { year: n - 1 }];
  }




  ngOnInit() {
    this.data.FechaInicio = new Date();
    //this.data.FechaFin = new Date();
  }

  getSocieties() {
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {

      this.loadBtn = false;
      if (data['EsValido']) {
        this.listSocieties = data['Entidades'];
        if (this.listSocieties.length == 1) {

          this.data.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety(0);

        }
      } else {
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if (err.status == 401) {
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(pos) {

    if (!this.providerActive) {

      console.log("providerActive %o", this.providerActive, pos);
      let List = this.listSocieties;
      this.arrOc = [];
      if (List[pos].NumProveedor) {
        this.arrOc.push(List[pos].NumProveedor);
      }
    }


    this.listPlantaSel = this.listPlanta.filter(x => x.IdSociedad == this.listSocieties[pos].IdSociedad || x.IdSociedad  == 0 );
    this.data.BusArea  = null;
    // console.log('lol')
    // const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
    // if(society.NumProveedor){
    //     this.arrOc = [];
    //     console.log(society.NumProveedor)
    //     this.data.Proveedor = society.NumProveedor;
    //     this.arrOc.push(society.NumProveedor);
    //     //this.data.provider = society.NumProveedor;
    // }
  }

  getPlantas(){
    this.provService.getPlantas(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listPlanta = data['Entidades'];

      }else{
        this.listPlanta = null;
      }
    }, (err) => {

      this.loadBtn = false;
      this.listPlanta = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectPlanta(index){

    const planta = this.listPlanta[index];
    if(planta.NoPlanta){
      this.data.BusArea = planta.BusArea; //.NoPlanta;
    }
  }


  disabledProv() {
    let resp = false;

    if (this.data.society) {
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
      if (society.NumProveedor) {

        resp = true;
      }
    }
    return resp;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.arrOc.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  search() {

    if (this.arrOc.length < 1 || !this.data.Sociedad || !this.data.FechaInicio
      //|| !this.data.FechaFin
    ) {
      this.toastr.error('Favor de agregar los datos obligatorios', 'Error');
      return;
    }

    this.data.Proveedores = this.arrOc.toString();
    this.loadBtn = true;

    this.provService.reportBills(this.data, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if (data['respuestaExitosa']) {
        this.listPayments = data['reporte'];
        this.temp = data['reporte'];
        this.totalesMoneda = data['totalMonedas'];
        this.getTotal();

        setTimeout(() => {
          this.filterDataExport();
        }, 500)
        this.step = 1;
      } else {
        this.toastr.info('No existen facturas disponibles', 'Ordenes');
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.toastr.error(err['error'][0].Response.Mensaje, 'Ordenes');
      if (err.status == 401) {
        this.gralService.actDeacUser(false);
      }
    });
  }

  getTotal() {
    setTimeout(() => {
      let tot = 0;
      let totLoc = 0;
      for (let g = 0; g < this.listPayments.length; g++) {
        tot += this.listPayments[g].Importe;
        totLoc += this.listPayments[g].ImporteLoc;
      }
      this.total = tot;
      this.totalLoc = totLoc;
    }, 500);
  }

  downloadReport() {
    this.provService.downloadReportPayments(this.data, this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      console.log(data);
      if (data['respuestaExitosa']) {
        const sampleBytes = this.base64ToArrayBuffer(data['File'].FileContent);
        const blob = new Blob([sampleBytes], { type: 'application/octet-stream' });
        saveAs(blob, data['File'].FileName);
      } else {
        this.toastr.info('No se puede descargar el archivo', 'Reporte pagos');
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.toastr.info('No se puede descargar el archivo', 'Reporte pagos');
      if (err.status == 401) {
        this.gralService.actDeacUser(false);
      }
    });
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if (string) {
          string.forEach(val => {
            if (val.trim()) {
              this.arrOc.push(val.trim());
            }
          });
        } else {
          if (value.trim()) {
            this.arrOc.push(value.trim());
          }
        }
      })
  }

  selectAll() {
    for (let g = 0; g < this.listPayments.length; g++) {
      this.listPayments[g].select = this.checkedAll;
    }
  }
  type;

  filterData(callbak) {
    let info;
    let docs = [];
    let finalList = [];

    for (let i = 0; i < this.listPayments.length; i++) {
      if (this.listPayments[i].select) {
        const datePipe = new DatePipe('en-US');
        finalList.push(this.listPayments[i].Proveedor);
      }
    }


    if (this.type != 'masive') {
      let list = [];

      for (let i = 0; i < this.listPayments.length; i++) {
        if (this.listPayments[i].select) {
          list.push({
            "Proveedor": this.listPayments[i].Proveedor,
            "Fecha": this.listPayments[i].Fecha,
            "Sociedad": this.listPayments[i].Sociedad,
            "NumeroDocumento": this.listPayments[i].NumeroDocumento
          })
        }
      }

      info = list;

    } else {
      info = {
        "Proveedores": this.arrOc.join(),
        "FechaInicio": this.data.FechaInicio,
        "FechaFin": this.data.FechaFin,
        "Sociedad": this.data.Sociedad
      }
    }



    return callbak(info);
  }



  /********************** exportar a excel ********************/
  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    //const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listpayments);
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, this.toExportFileName('Reporte_complemento_pagos'));
  }

  listExport = [];
  filterDataExport() {
    const datePipe = new DatePipe('en-US');

    let obj = this.temp;
    this.listExport = [];
    for (let i = 0; i < obj.length; i++) {
      let objInclude = {
        "Proveedor": obj[i].Proveedor,
        "Razón social": obj[i].RazonSocial,
        "Sociedad": obj[i].Sociedad,
        //"No. documento compensación": obj[i].DocumentoCompensación,
        "Referencia": obj[i].Referencia,
        "Fecha": datePipe.transform(obj[i].Fecha, 'yyyy/MM/dd'),
        "Importe en ML": obj[i].ImporteLoc,
        "Importe en MD": obj[i].Importe,
        "Moneda": obj[i].Moneda,
        //"UUIDS complemento": obj[i].UUIDComplemento,
        "UUID SAP": obj[i].UUIDSAP,
        //"Mensaje validación": obj[i].MensajeValidacion,
        //"Email proveedor": obj[i].EmailProveedor,
        //"Email usuario": obj[i].EmailUsuario
      };
      this.listExport.push(objInclude);
    }
  }

}
